module.exports = __webpack_public_path__ + "assets/img/footer-blob-top-left.d8a289e8.png";